import React from 'react'
import Slider from 'react-slick'

import TestimonialCard from './cards/testimonial'
import Award from '../assets/images/award.svg'

const settings = {
  speed: 600,
  fade: true,
  autoplay: false,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  cssEase: 'ease',
  swipe: false,
  focusOnSelect: false,
  adaptiveHeight: true,
  pauseOnHover: true
}

const AgentProfileAwards = ({ testimonials, achievements }) => {

  const perChunk = 2
  const quotes = testimonials.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / perChunk)

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [] // start a new chunk
    }

    resultArray[chunkIndex].push(item)

    return resultArray
  }, [])

  return (
    <section className='agent-awards'>
      <div className='agent-awards__inner'>
        {quotes?.length > 0 &&
          <div className='agent-testimonials'>
            <h3>Testimonials</h3>
            <Slider {...settings}>
              {quotes.map((el, i) => (
                <div className='testimonials__slide' key={i}>
                  <TestimonialCard noclick={true} {...el[0]} />
                  {el.length > 1 && <TestimonialCard noclick={true} {...el[1]} />}
                </div>
              ))}
            </Slider>
          </div>
        }
        {achievements?.length > 0 &&
          <div className='agent-achievements'>
            <h3>Achievements</h3>
            {achievements.map((el, i) => (
              <div className='agent-achievements__item' key={i}>
                <img src={Award} alt='Kollosche Award' />
                <div>
                  <span className='year'>{el.year}</span>
                  <h4 dangerouslySetInnerHTML={{ __html: el.title }} />
                  <p>{el.text}</p>
                </div>
              </div>
            ))}
          </div>
        }
      </div>

    </section>
  )
}

AgentProfileAwards.defaultProps = {
  achievements: [],
  testimonials: [],
}

export default AgentProfileAwards